import { createApp } from 'vue'
import GeneralSearch from './GeneralSearch'

const el = '.kb-component--general-search'
const DOMs = document.querySelectorAll(el)

export default function (Store) {
    if (DOMs && DOMs.length) {
        DOMs.forEach((DOM) => {
            const guid = DOM.dataset.guid
            const type = DOM.dataset.type
            const firstPageSize = parseInt(DOM.dataset.firstPageSize) ?? 10
            const showMorePageSize =
                parseInt(DOM.dataset.showMorePageSize) ?? 10
            const spotCardData = DOM.dataset.spotCard
                ? JSON.parse(DOM.dataset.spotCard)
                : null
            const hideNoResults = DOM.hasAttribute('hide-no-results')
            const avoidSetQueryInUrl = DOM.hasAttribute('avoid-set-query-in-url')
            const isMultisearch = DOM.hasAttribute('is-multisearch')
            const component = createApp(GeneralSearch,{
                guid,
                type,
                firstPageSize,
                showMorePageSize,
                spotCardData,
                hideNoResults,
                avoidSetQueryInUrl,
                isMultisearch
            }).use(Store)

            const mountOn = DOM.id ? `#${DOM.id}` : el
            component.mount(mountOn)
        })
    }
}
